import classNames from 'classnames';
import PropTypes from 'prop-types';
import GoogleNewsIcon from '@/lib/assets/images/google-news.svg';
import GoogleDiscoverIcon from '@/lib/assets/images/google-discover.svg';
import GoogleStarIcon from '@/lib/assets/images/google.svg';
import Heading from '@/components/Heading/Heading';

export default function GoogleButtons({ className }) {
  return (
    <div
      className={classNames(
        '[&_a]:whitespace-wrap [&_a]:flex [&_a]:items-center [&_a]:justify-center [&_a]:gap-1 [&_a]:!leading-3 [&_a]:px-3 [&_a]:md:px-4 max-lg:[&_a]:text-xs',
        '[&_span]:pb-1',
        '[&_a>svg]:size-5 [&_a>svg]:!fill-none [&_a>svg]:!stroke-none',
        className
      )}
    >
      <Heading level={`h2`} className={`mom-section-heading text-center mb-4 lg:text-left lg:text-3xl`}>Follow Us On</Heading>

      <div className='grid grid-cols-3 gap-2 lg:gap-4 lg:flex lg:flex-row lg:justify-start'>
        {/* Follow on Google Discovery */}
        <a
          href="https://profile.google.com/cp/Cg0vZy8xMWw2NXM0ODVn"
          target="_blank"
          rel="noopener noreferrer"
          className="mom-btn"
          aria-label="Follow Man of Many on Google Discovery"
        >
          <GoogleDiscoverIcon className="mom-true-svg" />
          Google <br className="md:hidden" />Discover
        </a>

        {/* Follow on Google News */}
        <a
          href="https://news.google.com/publications/CAAqKAgKIiJDQklTRXdnTWFnOEtEVzFoYm05bWJXRnVlUzVqYjIwb0FBUAE?hl=en-AU&gl=AU&ceid=AU:en"
          target="_blank"
          rel="noopener noreferrer"
          className="mom-btn"
          aria-label="Follow Man of Many on Google News"
        >
          <GoogleNewsIcon className="mom-true-svg" />
          Google <br className="md:hidden" />News
        </a>

        {/* Add as Preferred Source */}
        <a
          href="https://google.com/preferences/source?q=manofmany.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mom-btn"
          aria-label="Add Man of Many as preferred source on Google"
        >
          <GoogleStarIcon className="mom-true-svg" />
          Preferred <br className="md:hidden" />Source
        </a>
      </div>
    </div>
  );
}

GoogleButtons.propTypes = {
  className: PropTypes.string,
};
